import {Component, Input} from '@angular/core';
import {RxComponent} from '../../../core/components/common/rx.component';
import {ReportGeneratorsService} from '../../../core/services/report-generators.service';
import {ConfigService} from '../../../core/services/config.service';
import { NotificationService } from 'app/core/services/notification.service';

declare var moment: any;
@Component({
    selector: 'itpx-settlement-download-csv',
    templateUrl: './settlement-download-csv.component.html',
    styleUrls: ['./settlement-download-csv.component.css']
})
export class SettlementDownloadCsvComponent extends RxComponent {

    @Input('data') data = null;
    public fileUrl = null;

    private currentFilter = 'settlement-pending';
    private fromSettlementDate = null;
    private toSettlementDate = null;
    private awsUrl = this.configService.get('aws').url;

    constructor(
        private reportGeneratorsService: ReportGeneratorsService,
        private configService: ConfigService,
        private notificationService: NotificationService) {
        super();
    }

    downloadSettlementReportCSV() {
        const startOfDay = moment(this.fromSettlementDate * 1000).startOf('day').toISOString();
        const endOfDay = this.toSettlementDate ? moment(this.toSettlementDate * 1000).endOf('day').toISOString() : moment(33151118524 * 1000).endOf('day').toISOString();

        this.reportGeneratorsService.generateSettlementReport({
            fromDate : startOfDay,
            toDate : endOfDay,
            configKey : this.currentFilter
        }).subscribe(() => this.notificationService.success('Report will be sent on your email', 'Success'));
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/settlement-download-csv/settlement-download-csv.component.ts